export const nfseCompanyErrorMappings = {
    NFSE_COMPANY_CEP_NOT_CONFIGURED: {
        code: 'NFSE_COMPANY_CEP_NOT_CONFIGURED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'CEP da empresa não está configurado. Configure o CEP antes de prosseguir.',
            },
            {
                language: 'pt-BR',
                message: 'CEP da empresa não está configurado. Configure o CEP antes de prosseguir.',
            },
            {
                language: 'en-US',
                message: 'Company ZIP code is not configured. Please configure the ZIP code before proceeding.',
            },
            {
                language: 'es-ES',
                message: 'El código postal de la empresa no está configurado. Configure el código postal antes de continuar.',
            },
        ],
        technicalMessage: 'CEP da empresa não configurado',
        severity: 'error',
        critical: false,
    },
    NFSE_IBGE_CEP_LOOKUP_ERROR: {
        code: 'NFSE_IBGE_CEP_LOOKUP_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Não foi possível consultar os dados do município pelo CEP. Tente novamente.',
            },
            {
                language: 'pt-BR',
                message: 'Não foi possível consultar os dados do município pelo CEP. Tente novamente.',
            },
            {
                language: 'en-US',
                message: 'Could not look up municipality data by ZIP code. Please try again.',
            },
            {
                language: 'es-ES',
                message: 'No fue posible consultar los datos del municipio por código postal. Intente nuevamente.',
            },
        ],
        technicalMessage: 'Erro ao buscar IBGE pelo CEP',
        severity: 'error',
        critical: false,
    },
    NFSE_CITY_STANDARD_QUERY_ERROR: {
        code: 'NFSE_CITY_STANDARD_QUERY_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Erro ao consultar o padrão de emissão do município. Tente novamente.',
            },
            {
                language: 'pt-BR',
                message: 'Erro ao consultar o padrão de emissão do município. Tente novamente.',
            },
            {
                language: 'en-US',
                message: 'Error querying the municipality emission standard. Please try again.',
            },
            {
                language: 'es-ES',
                message: 'Error al consultar el estándar de emisión del municipio. Intente nuevamente.',
            },
        ],
        technicalMessage: 'Erro na consulta do padrão do município',
        severity: 'error',
        critical: false,
    },
    NFSE_CITY_STANDARD_NOT_FOUND: {
        code: 'NFSE_CITY_STANDARD_NOT_FOUND',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Não foi possível identificar o padrão de emissão do município.',
            },
            {
                language: 'pt-BR',
                message: 'Não foi possível identificar o padrão de emissão do município.',
            },
            {
                language: 'en-US',
                message: 'Could not identify the municipality emission standard.',
            },
            {
                language: 'es-ES',
                message: 'No fue posible identificar el estándar de emisión del municipio.',
            },
        ],
        technicalMessage: 'Não foi possível obter o padrão do município',
        severity: 'error',
        critical: false,
    },
};
